import { render, staticRenderFns } from "./ReadPage.vue?vue&type=template&id=0ee5723d&scoped=true&"
import script from "./ReadPage.vue?vue&type=script&lang=js&"
export * from "./ReadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee5723d",
  null
  
)

export default component.exports